<template>
<Button class="gyl-btn" v-if="auth[id]&&shape" shape="circle" :ghost="ghost" @click="click(auth[id],data)" :type="type" :icon="ico" :size="size" :loading="loading" ><slot></slot></Button>
<Button class="gyl-btn" v-else-if="auth[id]" :ghost="ghost" @click="click(auth[id],data)" :type="type" :icon="ico" :size="size" :loading="loading" ><slot></slot></Button>
</template>
<script>
export default {
	name: 'btn',
	props: {
		ghost: {
			type: Boolean,
			default:false
		},
		shape: {
			type: Boolean,
			default:false
		},
		type: {
			type: String,
			default:'primary'
		},
		size: {
			type: String,
			default:'default'
		},
		icon: {
			type: String,
			default:''
		},
		title: {
			type: String,
			default:''
		},
		data: {
			type: Object,
			default:() => ({})
		},
		id: {
			type: [String,Number],
			default:''
		},
		loading: {
			type: Boolean,
			default:false
		},
		callback: {
			type: Boolean,
			default:false
		}
	},
	data() {
		return {
			auth:{}
		}
	},
	created(){
		this.getAuth();
	},
	computed: {
		ico(){
			return this.icon!=''?this.icon:this.auth[this.id].icon;
		},
		tit(){
			return this.title!=''?this.title:this.auth[this.id].meta.title;
		},
	},
	methods: {
		getAuth(){
			if(this.$route.meta.auth) this.auth=this.$route.meta.auth;
		},
		click(btn,data){
			if(this.callback) return this.$emit('callback',btn);
			const para = Object.assign({},btn.meta.para,{_PATH:this.$route.path});
			if(para.dotype=="del"){
				this.$Modal.confirm({
                    title: '确认删除此信息吗？',
                    onOk: () => {
                        this.$ajax.post(btn.path,data).then(data => {
							if(data.status==this.$ajax.HTTP_S){
								this.$Message.success({content:data.message,closable: true});
								this.$router.push({path:this.$route.path,query:{refresh:new Date().getTime()}});
							}
							if(data.status==this.$ajax.HTTP_F) this.$Message.error({content:data.message,closable: true});
						});
                    }
                });
			}
			else if(para.type=="tag") this.$router.push({name:btn.name,params:{data:data,para:para}});
			else if(para.type=="dialog")
				this.$Dialog.show({title:btn.meta.title,component:btn.component,name:btn.name,params:{data:data,para:para}});

		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/inc/btns/btn.vue